export default __webpack_public_path__ + "static/media/latest_badge.fe7cc320.svg";